import useApi from '../../components/js/Composables/useApi'

export default function useSubscriberApi() {
  const { getJSON } = useApi()

  async function get(internalName: string): Promise<Subscriber> {
    return await getJSON(`subscribers/${internalName}`)
  }

  return {
    get,
  }
}
